export const environment = {
  production: false,
  name: 'homolog',
  apiUrl: 'https://api-staging.ieczonasul.com.br/'
};
